<div> 
    <app-bi-relatorio-analise-filtro
          [filtros]="filtros">
    </app-bi-relatorio-analise-filtro>
    <app-bi-relatorio-analise-lista
          [filtros]="filtros"
          (definirFiltro)="definirFiltro()"
          (exibir)="selecionar($event)">
    </app-bi-relatorio-analise-lista>
   </div>